/**
 * Created by henian.xu on 2018/7/19.
 *
 */

import Servant from './Servant';
import ServantPaymentConfig from './ServantPaymentConfig';
import ServantDecoration from './ServantDecoration';
import CertCat from './CertCat';
import QuestionCat from './QuestionCat';
import Question from './Question';
import CourseCat from './CourseCat';
import Course from './Course';
import ServantGoodsCat from './ServantGoodsCat';
import ServantExpress from './ServantExpress';
import ServantFreightTemplate from './ServantFreightTemplate';
import PaperTemplate from './PaperTemplate';
import ApplyMaterials from './ApplyMaterials';
import ApplyMaterialsCat from './ApplyMaterialsCat';
import ApplyTemplate from './ApplyTemplate';
import AppraisalRule from './AppraisalRule';
import CertExamCourse from './CertExamCourse';
import CertExamCourseCat from './CertExamCourseCat';
import CertExamCourseDetail from './CertExamCourseDetail';
import CertExam from './CertExam';
import ExamPaperExperience from './ExamPaperExperience';
import Teacher from './Teacher';
import TeacherCertificate from './TeacherCertificate';
import TeacherCalendar from './TeacherCalendar';
import Classroom from './Classroom';
import ClassroomCalendar from './ClassroomCalendar';
import MaterialsValue from './MaterialsValue';
import Courseware from './Courseware';
import CoursewareCat from './CoursewareCat';

export default {
    Servant,
    ServantPaymentConfig,
    ServantDecoration,
    CertCat,
    QuestionCat,
    Question,
    CourseCat,
    Course,
    ServantGoodsCat,
    ServantExpress,
    ServantFreightTemplate,
    PaperTemplate,
    ApplyMaterials,
    ApplyMaterialsCat,
    ApplyTemplate,
    AppraisalRule,
    CertExamCourse,
    CertExamCourseCat,
    CertExamCourseDetail,
    CertExam,
    ExamPaperExperience,
    Teacher,
    TeacherCertificate,
    TeacherCalendar,
    Classroom,
    ClassroomCalendar,
    MaterialsValue,
    Courseware,
    CoursewareCat,
};
